import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Global } from '@nike/nike-design-system-icons';
import Link from '../Link';
import { mobileOnly, desktopOnly } from '../../utils/sharedStyles';

/*
  TODO: Styling on this doesn't work if starting from mobile size.
  It could be because i am utilizing max with instead? Not too sure
  why it is happening so look into this. If i go from mobile ->
  desktop -> mobile then it works just fine upon returning. Looks
  like it may
*/
export const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  height: 21px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  font: var(--podium-cds-typography-body2-strong);
  color: var(--podium-cds-color-text-secondary);

  @media (${mobileOnly}) {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  @media (${desktopOnly}) {
    justify-content: flex-end;
  }
`;

const smallIcon = css`
  width: var(--podium-cds-size-icon-s);
  height: var(--podium-cds-size-icon-s);
`;

/**
 * Renders the language tunnel country selector button
 * Podium does not currently support a "small" text button with icon
 * Overriding the color and font size to match figma
 */
export const LanguageTunnelBtn = styled(Link)`
  font: var(--podium-cds-typography-body2-strong) !important;
  color: var(--podium-cds-color-text-secondary) !important;
  &:focus {
    color: var(--podium-cds-color-text-secondary) !important;
  }
  .btn-icon-wrapper {
    ${smallIcon}
    svg {
      transform: translateY(3px);
      ${smallIcon}
    }
  }
  &:hover:not(:disabled) {
    color: var(--podium-cds-color-text-secondary);
  }
`;

/**
 * Renders a small globe icon
 * Podium does not currently support a "small" Globe icon
 */
export const SmallGlobalIcon = styled(Global)`
  ${smallIcon}
`;
